import { commonGuard } from "../func"
import { getCurrentLanguage } from "@/i18n"

const deviceRouter = {
  path: "device",
  name: "device-root",
  redirect: () => ({ name: "deviceAll", params: { groupPk: "all", lang: getCurrentLanguage() } }),
  component: () => import("@/components/frame/main.vue"),
  children: [
    {
      path: ":groupPk",
      name: "deviceAll",
      beforeEnter: commonGuard,
      component: () => import("@/components/device/index.vue"),
      children: [
        {
          path: ":devicePk",
          name: "device-detail",
          component: () => import("@/components/device/detail.vue"),
          beforeEnter: commonGuard,
          props: true,
        },
      ],
    },
  ],
}

export default deviceRouter
